import { formatNumberAsCurrency } from "./number";

export const formatStringAsCurrency = (input: string) => {
  const valueToFormat = input ?? "0";
  // Remove non-numeric characters except dot
  const numeric = valueToFormat.replace(/[^0-9.]/g, "");
  const amount = parseFloat(numeric);
  if (isNaN(amount)) return "";
  return formatNumberAsCurrency(amount);
};

export const formatPhoneNumber = (input: string): string => {
  // Remove all non-digit characters
  const digits = input.replace(/\D/g, "");

  if (digits.length !== 10) {
    return input;
    throw new Error("Phone number must contain exactly 10 digits.");
  }

  const areaCode = digits.slice(0, 3);
  const centralOfficeCode = digits.slice(3, 6);
  const lineNumber = digits.slice(6);

  return `(${areaCode}) ${centralOfficeCode}-${lineNumber}`;
};
